import React from "react";

const PrimaryButton = ({ children, className, ...props }) => {
  return (
    <button
      className={`btn bg-black rounded-full px-[30px] text-white ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
